/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import { Glow } from '@/components/ui/glow';
import { cn } from '@/lib/utils';
import { Marck_Script } from 'next/font/google';

export const fontHandwritten = Marck_Script({
  weight: ['400'],
  style: 'normal',
  subsets: ['latin'],
});

export function HeroWithMockup() {
  return (
    <section
      className={cn(
        'relative bg-background text-foreground',
        'px-4 py-12 md:py-20',
        'overflow-hidden',
      )}
    >
      <div className="relative mx-auto flex max-w-[1280px] flex-col gap-12 lg:gap-24">
        <div className="relative z-10 flex flex-col items-center gap-2 pt-8 text-center md:pt-16 lg:gap-5">
          <div className="mx-auto mt-5 max-w-5xl text-center">
            <h5 className="block animate-appear text-center text-4xl font-bold text-gray-800 opacity-0 drop-shadow-sm dark:drop-shadow-[0_0_15px_rgba(255,255,255,0.1)] md:text-5xl lg:text-7xl">
              <span className="block">
                <span className={cn('', fontHandwritten.className)}>
                  Rise Stronger, Live Better
                </span>{' '}
                <br />
                <span className="uppercase text-gray-800">Expert</span>
                <span className="uppercase text-brand"> Rehab Solutions</span>
                <span className="uppercase text-gray-800"> for You</span>
                <span className={cn('ml-2', fontHandwritten.className)}></span>
              </span>
              <span className="mt-3 block text-gray-800 dark:text-gray-300">
                {/* <span className={cn("ml-1 text-[#408ecc]", fontHandwritten.className)}>
                  Rehab Solutions
                </span>{" "} */}
              </span>
            </h5>
          </div>

          <div className="mx-auto mt-2 max-w-2xl animate-appear text-center opacity-0 [animation-delay:150ms]">
            <p className="text-lg text-gray-600">
              Take control of your recovery journey with personalized therapies
              designed to rebuild strength, restore confidence, and enhance
              well-being. Your path to healing begins here.
            </p>
          </div>

          {/* CTAs */}
          <div className="relative z-10 flex animate-appear flex-wrap justify-center gap-4 opacity-0 [animation-delay:300ms]">
            <div className="flex size-full flex-col items-center justify-center gap-4 sm:flex-row">
              <a
                className="inline-flex items-center gap-x-2 rounded-full bg-primary px-6 py-3 text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary/90 focus:bg-primary/90 focus:outline-none"
                href="/appointment"
              >
                <svg
                  className="size-4 shrink-0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M8 2v4" />
                  <path d="M16 2v4" />
                  <rect width="18" height="18" x="3" y="4" rx="2" />
                  <path d="M3 10h18" />
                </svg>
                Book Appointment
              </a>

              <a
                className="inline-flex items-center gap-x-2 rounded-full border border-gray-200 bg-white px-6 py-3 text-sm font-medium text-gray-800 shadow-sm transition-colors hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
                href="/about"
              >
                <svg
                  className="size-4 shrink-0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 16v-4" />
                  <path d="M12 8h.01" />
                </svg>
                Learn More
              </a>

              <a
                className="inline-flex items-center gap-x-2 rounded-full border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-800 shadow-sm transition-colors hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
                href="https://www.facebook.com/rehabsolutionsplus"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  className="size-4 shrink-0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
                Watch Video
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Background Glow */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <Glow
          variant="above"
          className="animate-appear-zoom opacity-0 [animation-delay:1000ms]"
        />
      </div>
    </section>
  );
}
